import React from 'react'
const Page404 = () =>{
    return (<div></div>);
}

export default Page404;